import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import CreateWorkflow from './CreateWorkFlow';

class WorkflowListSAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingWorkflow: false,
            allWorkFlow: [],
            message: ""
        }
    }

    componentDidMount() {
        // if(sessionStorage.getItem('selected_workflow') == null || sessionStorage.getItem('selected_workflow') == undefined || sessionStorage.getItem('selected_workflow') ===""){
        //     // window.location.href = '/create/workflow'
        //     return
        // }
        this.getTotalType()
    }
    getTotalType = () => {
        let site_info = sessionStorage.getItem('c_admin_s_workflowlist');
        if (site_info == "") {
            return
        }

        var data = {
            jwt: jwt,
            sid: JSON.parse(site_info).id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/Workflow/workflows`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.workflow) {
                        _this.setState({ allWorkFlow: response.data.workflow, message: response.data.workflow.length === 0 ? "No Record Found." : "" });
                    }
                }else{
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });
            
        };
    }


    createWorkflow = () => {
        this.setState({ creatingWorkflow: true })
    }
    taskManageVersion = (list) => {
        window.location.href = "/create/workflowversionlist"
        sessionStorage.setItem("selected_workflow", list.id);
        sessionStorage.setItem("selected_workflow_description", JSON.stringify(list));
    }

    render() {
console.log(this)
        const { errors } = this.state;
        return (
          <div>
            <div className="xp-breadcrumbbar">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <h4 className="xp-page-title">Workflow</h4>
                </div>
                <div className="col-md-12 col-lg-12">
                  <div className="xp-breadcrumb gradient-border">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <a onClick={() => (window.location.href = "/dashboard")}>
                          <i class="icon-home"></i>
                        </a>
                      </li>
                      <li class="breadcrumb-item active" onClick={() => (window.location.href = "/create/listsadmin")}>
                        Site List
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="xp-contentbar p-30" style={{paddingBottom:"0"}}>
              <div className="row">
                <div className="col-lg-12 xpcontent2">
                  <div className="card m-b-30">
                    <div className="card-header dv-center space-between">
                      <h5 className="card-title text-black mb-0">Workflow Table</h5>
                      {/* <button className="btn btn-primary btn-lg" title="create workflow" onClick={this.createWorkflow}><i className="mdi mdi-plus"></i> Create New</button> */}
                    </div>

                    <div className="card-body">
                      <div className="table-responsive">
                        {this.state.allWorkFlow.length === 0 ? (
                          this.state.message === "" ? (
                            // loader
                            <div className="lds-spinner">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          ) : (
                            // loader-end
                            <div className="message-no-record"> {this.state.message} </div>
                          )
                        ) : null}
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th className="text-center" style={{ width: "5%" }}>
                                No
                              </th>
                              <th style={{ width: "20%" }}>Title</th>
                              <th>Description</th>
                              {/* <th className="text-center" style={{ width: "15%" }}>Action</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.allWorkFlow.map((list, index) => (
                              <tr>
                                <td className="text-center">
                                  <strong>{index + 1}.</strong>
                                </td>
                                <td>{list.title}</td>
                                <td>{list.description}</td>
                                {/* <td className="text-center">
                                                            <div className="tabledit-toolbar btn-toolbar" style={{ margin: "0 auto", display: "block" }}>
                                                                <div className="btn-group btn-group-sm">
                                                                    <button type="button" onClick={() => this.taskManageVersion(list)} className=" btn btn-info">Manage Version</button>
                                                                </div>
                                                            </div>
                                                        </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {this.state.creatingWorkflow ? (
                        <div id="popup" className="overlay">
                          <div className="modal-dialog" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title mt-0">Create Workflow</h5>
                                <button
                                  type="button"
                                  className="close"
                                  onClick={() => this.setState({ creatingWorkflow: false })}
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <CreateWorkflow />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
export default WorkflowListSAdmin

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}